import React from "react";
import { Button } from "@mui/material";

export default function ConnectWallet({
  web3Modal,
  loadWeb3Modal,
  logoutOfWeb3Modal,
}) {
  const modalButtons = [];
  if (web3Modal) {
    console.log(web3Modal.cachedProvider);
    if (web3Modal.cachedProvider) {
      modalButtons.push(
        <Button
          variant="contained"
          sx={{
            borderRadius: "20px",
            bgcolor: "#B6E094",
            color: "#000",
            px: "15px",
          }}
          onClick={logoutOfWeb3Modal}
        >
          DISCONNECT
        </Button>
      );
    } else {
      modalButtons.push(
        <Button
          variant="contained"
          sx={{
            borderRadius: "20px",
            bgcolor: "#B6E094",
            color: "#000",
            px: "15px",
          }}
          onClick={loadWeb3Modal}
        >
          Connect&nbsp;Wallet
        </Button>
      );
    }
  }

  return <div>{modalButtons}</div>;
}
